import { HttpInterceptorFn } from '@angular/common/http';

export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api/labirinto/') && !req.url.includes('/auth/login')) {
    const token = sessionStorage.getItem('labirinto_admin_token');
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }
  return next(req);
};
